/* ============================================================
   Movataa — Snail Face Cream v3 JS
   Sticky bar + FAQ accordion
   ============================================================ */

(function () {
  'use strict';

  /* ── Sticky bar ── */
  function initStickyBar() {
    const bar = document.querySelector('.sv3-sticky');
    if (!bar) return;

    // Show bar once the main product buy-buttons scroll out of view
    const sentinel = document.querySelector('.product-form__buttons, .shopify-payment-button, [data-type="buy_buttons"]');
    if (!sentinel) {
      // Fallback: show after 600px scroll
      window.addEventListener('scroll', function () {
        if (window.scrollY > 600) {
          bar.classList.add('sv3-sticky--visible');
        } else {
          bar.classList.remove('sv3-sticky--visible');
        }
      }, { passive: true });
      return;
    }

    const obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          bar.classList.add('sv3-sticky--visible');
        } else {
          bar.classList.remove('sv3-sticky--visible');
        }
      });
    }, { threshold: 0.1 });

    obs.observe(sentinel);
  }

  /* ── FAQ accordion ── */
  function initFaq() {
    document.querySelectorAll('.sv3-faq__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const item = btn.closest('.sv3-faq__item');
        const answer = item.querySelector('.sv3-faq__a');
        const isOpen = item.classList.contains('sv3-open');

        // Close all
        document.querySelectorAll('.sv3-faq__item').forEach(function (i) {
          i.classList.remove('sv3-open');
          i.querySelector('.sv3-faq__q').setAttribute('aria-expanded', 'false');
          const a = i.querySelector('.sv3-faq__a');
          if (a) a.removeAttribute('hidden');
        });

        // Toggle open state — remove hidden so CSS max-height works
        if (!isOpen) {
          item.classList.add('sv3-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Remove hidden attr from all answers on init so CSS transition works
    document.querySelectorAll('.sv3-faq__a').forEach(function (a) {
      a.removeAttribute('hidden');
    });
  }

  /* ── Init ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initStickyBar();
      initFaq();
    });
  } else {
    initStickyBar();
    initFaq();
  }
})();
